// extracted by mini-css-extract-plugin
export default {"container":"CommonQrReader_container__WpCm+","button-close":"CommonQrReader_button-close__TlnEk"};